var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isActive && _vm.hasSlotOrContent)?_vm._t("default",[_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.contentText)+" ")])]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }